export default "__VITE_ASSET__dde04154__"